module.exports = __webpack_public_path__ + "img/tour-61.016d5337.png";